import { render, staticRenderFns } from "./invoiceRecordDetailEdit.vue?vue&type=template&id=97f8f40c&scoped=true&"
import script from "./invoiceRecordDetailEdit.vue?vue&type=script&lang=js&"
export * from "./invoiceRecordDetailEdit.vue?vue&type=script&lang=js&"
import style0 from "./invoiceRecordDetailEdit.vue?vue&type=style&index=0&id=97f8f40c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f8f40c",
  null
  
)

export default component.exports